{
  "about.accept_legacy_quotes": "Automatski prihvati naslijeđene citate",
  "about.blocks": "Moderirani serveri",
  "about.contact": "Kontakt:",
  "about.default_locale": "Zadano",
  "about.disabled": "Onemogućeno",
  "about.disclaimer": "Budite dio nečeg stvarnog - pridružite se našoj zajednici i govorite slobodno, izvan dosega velikih tehnoloških kompanija.",
  "about.domain_blocks.no_reason_available": "Razlog nije dostupan",
  "about.domain_blocks.noop.explanation": "Ovaj poslužitelj je djelomično ograničen.",
  "about.domain_blocks.noop.title": "Blago ograničen",
  "about.domain_blocks.preamble": "Mastodon vam općenito dopušta pregledavanje sadržaja i interakciju s korisnicima s bilo kojeg drugog poslužitelja u fediverzumu. Ovo su iznimke koje su napravljene na ovom poslužitelju.",
  "about.domain_blocks.silenced.explanation": "Općenito nećete vidjeti profile i sadržaj s ovog poslužitelja, osim ako ga izričito ne potražite ili se odlučite pratiti.",
  "about.domain_blocks.silenced.title": "Ograničen",
  "about.domain_blocks.suspended.explanation": "Nikakvi podaci s ovog poslužitelja neće biti obrađeni, pohranjeni ili razmijenjeni, što onemogućava bilo kakvu interakciju ili komunikaciju s korisnicima s ovog poslužitelja.",
  "about.domain_blocks.suspended.title": "Suspendiran",
  "about.enabled": "Omogućeno",
  "about.full_text_search": "Pretraživanje cijelog teksta",
  "about.kmyblue_capabilities": "Značajke dostupne na ovom poslužitelju",
  "about.kmyblue_capability": "Jedinstvene značajke poslužitelja konfigurirane su kako slijedi.",
  "about.language_label": "Jezik",
  "about.not_available": "Ove informacije nisu dostupne na ovom poslužitelju.",
  "about.powered_by": "Tvoja mreža!",
  "about.public_visibility": "Javna vidljivost",
  "about.rules": "Pravila poslužitelja",
  "account.account_note_header": "Osobna bilješka",
  "account.activity": "Aktivnost",
  "account.add_or_remove_from_antenna": "Dodaj ili ukloni iz antena",
  "account.add_or_remove_from_circle": "Dodaj ili ukloni iz krugova",
  "account.add_or_remove_from_exclude_antenna": "Dodaj ili ukloni iz antena kao isključenje",
  "account.add_or_remove_from_list": "Dodaj ili ukloni s popisa",
  "account.badges.admin": "Admin",
  "account.badges.bot": "Automatiziran",
  "account.badges.group": "Grupa",
  "account.block": "Blokiraj @{name}",
  "account.block_domain": "Blokiraj domenu {domain}",
  "account.block_short": "Blokiraj",
  "account.blocked": "Blokiran",
  "account.blocking": "Blokiranje",
  "account.cancel_follow_request": "Otkaži praćenje",
  "account.copy": "Kopiraj poveznicu na profil",
  "account.direct": "Privatno spomeni @{name}",
  "account.disable_notifications": "Prestani me obavještavati kada @{name} objavi",
  "account.domain_blocking": "Blokiranje domene",
  "account.edit_profile": "Uredi profil",
  "account.edit_profile_short": "Uredi",
  "account.enable_notifications": "Obavijesti me kada @{name} objavi",
  "account.endorse": "Istakni na profilu",
  "account.familiar_followers_many": "Prati {name1}, {name2} i {othersCount, plural, one {jedan drugi koga poznajete} other {# druge koje poznajete}}",
  "account.familiar_followers_one": "Prati {name1}",
  "account.familiar_followers_two": "Prati {name1} i {name2}",
  "account.featured": "Istaknuto",
  "account.featured.accounts": "Profili",
  "account.featured.hashtags": "Oznake",
  "account.featured_tags.last_status_at": "Zadnja objava {date}",
  "account.featured_tags.last_status_never": "Nema objava",
  "account.follow": "Prati",
  "account.follow_back": "Zaprati natrag",
  "account.follow_back_short": "Zaprati natrag",
  "account.follow_request": "Zahtjev za praćenjem",
  "account.follow_request_cancel": "Otkaži zahtjev",
  "account.follow_request_cancel_short": "Otkaži",
  "account.follow_request_short": "Zahtjev",
  "account.followers": "Pratitelji",
  "account.followers.empty": "Nitko još ne prati ovog korisnika.",
  "account.followers.hidden_from_me": "Ovu informaciju skriva vaša postavka.",
  "account.followers_counter": "{count, plural, one {{counter} pratitelj} other {{counter} pratitelja}}",
  "account.followers_you_know_counter": "{counter} koje poznajete",
  "account.following": "Prati",
  "account.following_counter": "{count, plural, one {{counter} pratim} other {{counter} pratim}}",
  "account.follows.empty": "Ovaj korisnik još ne prati nikoga.",
  "account.follows_you": "Prati vas",
  "account.go_to_profile": "Idi na profil",
  "account.hide_reblogs": "Sakrij pojačanja od @{name}",
  "account.in_memoriam": "U sjećanje.",
  "account.joined_short": "Pridružio/la se",
  "account.languages": "Promijeni pretplaćene jezike",
  "account.link_verified_on": "Vlasništvo nad ovom poveznicom provjereno je {date}",
  "account.locked_info": "Privatnost ovog računa je postavljena na zaključano. Vlasnik ručno pregledava tko ga može pratiti.",
  "account.media": "Mediji",
  "account.mention": "Spomeni @{name}",
  "account.menu.block": "Blokiraj račun",
  "account.menu.block_domain": "Blokiraj {domain}",
  "account.menu.copy": "Kopiraj poveznicu",
  "account.menu.mention": "Spomeni",
  "account.menu.remove_follower": "Ukloni pratitelja",
  "account.menu.report": "Prijavi račun",
  "account.moved_to": "{name} je naznačio/la da je njegov/njezin novi račun sada:",
  "account.mute": "Utišaj @{name}",
  "account.mute_notifications_short": "Utišaj obavijesti",
  "account.mute_short": "Utišaj",
  "account.muted": "Utišan",
  "account.muting": "Utišavanje",
  "account.mutual": "Pratite jedan drugog",
  "account.no_bio": "Nema opisa.",
  "account.node_modal.save": "Spremi",
  "account.note.edit_button": "Uredi",
  "account.open_original_page": "Otvori izvornu stranicu",
  "account.posts": "Objave",
  "account.posts_with_replies": "Objave i odgovori",
  "account.remove_from_followers": "Ukloni {name} iz sljedbenika",
  "account.report": "Prijavi @{name}",
  "account.requested": "Čekanje na potvrdu. Kliknite za poništavanje zahtjeva za praćenje",
  "account.requested_follow": "{name} je zatražio/la da vas prati",
  "account.requests_to_follow_you": "Zahtjevi za praćenjem",
  "account.share": "Podijeli profil @{name}",
  "account.show_reblogs": "Prikaži pojačanja od @{name}",
  "account.statuses_counter": "{count, plural, one {{counter} objava} other {{counter} objava}}",
  "account.unblock": "Odblokiraj @{name}",
  "account.unblock_domain": "Odblokiraj domenu {domain}",
  "account.unblock_domain_short": "Odblokiraj",
  "account.unblock_short": "Odblokiraj",
  "account.unendorse": "Ne isticati na profilu",
  "account.unfollow": "Prestani pratiti",
  "account.unmute": "Poništi utišavanje @{name}",
  "account.unmute_notifications_short": "Poništi utišavanje obavijesti",
  "account.unmute_short": "Poništi utišavanje",
  "account_edit.bio.title": "Biografija",
  "account_edit.bio_modal.add_title": "Dodaj biografiju",
  "account_edit.bio_modal.edit_title": "Uredi biografiju",
  "account_edit.column_button": "Završi",
  "account_edit.column_title": "Uredi profil",
  "account_edit.custom_fields.title": "Prilagođena polja",
  "account_edit.featured_hashtags.title": "Istaknuti hashtagovi",
  "account_edit.save": "Spremi",
  "account_note.placeholder": "Klikni za dodavanje bilješke",
  "admin.dashboard.daily_retention": "Stopa zadržavanja korisnika po danima nakon prijave",
  "admin.dashboard.monthly_retention": "Stopa zadržavanja korisnika po mjesecima nakon prijave",
  "admin.dashboard.retention.average": "Prosjek",
  "admin.dashboard.retention.cohort": "Mjesec prijave",
  "admin.dashboard.retention.cohort_size": "Novi korisnici",
  "admin.dimenssions.disabled_key": "Ova informacija je nevažeća.",
  "admin.impact_report.instance_accounts": "Profili računa koje bi ovo izbrisalo",
  "admin.impact_report.instance_followers": "Pratitelji koje bi naši korisnici izgubili",
  "admin.impact_report.instance_follows": "Pratitelji koje bi njihovi korisnici izgubili",
  "admin.impact_report.title": "Sažetak utjecaja",
  "alert.rate_limited.message": "Pokušajte ponovno nakon {retry_time, time, medium}.",
  "alert.rate_limited.title": "Ograničena stopa",
  "alert.unexpected.message": "Došlo je do neočekivane pogreške.",
  "alert.unexpected.title": "Ups!",
  "alt_text_badge.title": "Alternativni tekst",
  "alt_text_modal.add_alt_text": "Dodaj alternativni tekst",
  "alt_text_modal.add_text_from_image": "Dodaj tekst sa slike",
  "alt_text_modal.cancel": "Otkaži",
  "alt_text_modal.change_thumbnail": "Promijeni sličicu",
  "alt_text_modal.describe_for_people_with_hearing_impairments": "Opiši ovo za osobe s oštećenjem sluha…",
  "alt_text_modal.describe_for_people_with_visual_impairments": "Opiši ovo za osobe s oštećenjem vida…",
  "alt_text_modal.done": "Gotovo",
  "announcement.announcement": "Obavijest",
  "annual_report.announcement.action_dismiss": "Ne hvala",
  "annual_report.nav_item.badge": "Novi",
  "annual_report.shared_page.donate": "Doniraj",
  "annual_report.summary.archetype.booster": "Lovac na trendove",
  "annual_report.summary.archetype.lurker": "Promatrač",
  "annual_report.summary.archetype.oracle": "Prorok",
  "annual_report.summary.archetype.pollster": "Anketar",
  "annual_report.summary.archetype.replier": "Društveni leptir",
  "annual_report.summary.followers.followers": "sljedbenika",
  "annual_report.summary.followers.total": "{count} ukupno",
  "annual_report.summary.here_it_is": "Evo vaše pregled godine {year}:",
  "annual_report.summary.highlighted_post.by_favourites": "objava s najviše favoriziranja",
  "annual_report.summary.highlighted_post.by_reblogs": "najpojačavanija objava",
  "annual_report.summary.highlighted_post.by_replies": "objava s najviše odgovora",
  "annual_report.summary.highlighted_post.possessive": "{name}",
  "annual_report.summary.most_used_app.most_used_app": "najkorištenija aplikacija",
  "annual_report.summary.most_used_hashtag.most_used_hashtag": "najkorištenija oznaka",
  "annual_report.summary.most_used_hashtag.none": "Nijedna",
  "annual_report.summary.new_posts.new_posts": "novih objava",
  "annual_report.summary.percentile.text": "<topLabel>To vas stavlja u top</topLabel><percentage></percentage><bottomLabel>korisnika {domain}.</bottomLabel>",
  "annual_report.summary.percentile.we_wont_tell_bernie": "Nećemo reći Bernieju.",
  "annual_report.summary.thanks": "Hvala što ste dio Mastodona!",
  "antennas.accounts": "{count} računa",
  "antennas.add_domain": "Dodaj domenu",
  "antennas.add_domain_placeholder": "Nova domena",
  "antennas.add_keyword": "Dodaj ključnu riječ",
  "antennas.add_keyword_placeholder": "Nova ključna riječ",
  "antennas.add_member": "Dodaj",
  "antennas.add_tag": "Dodaj oznaku",
  "antennas.add_tag_placeholder": "Nova oznaka",
  "antennas.add_to_antenna": "Dodaj u antenu",
  "antennas.add_to_antennas": "Dodaj {name} u antene",
  "antennas.antenna_accounts": "Računi antene",
  "antennas.antenna_accounts_count": "{count, plural, one {# član} other {# članova}}",
  "antennas.antenna_name": "Naziv antene",
  "antennas.badge_ltl": "LTL",
  "antennas.badge_stl": "STL",
  "antennas.create": "Kreiraj",
  "antennas.create_a_antenna_to_organize": "Kreiraj novu antenu za organiziranje vašeg početnog feeda",
  "antennas.create_antenna": "Kreiraj antenu",
  "antennas.delete": "Izbriši antenu",
  "antennas.destination": "Odredište",
  "antennas.destination.home": "Umetni u početni",
  "antennas.destination.list": "Umetni u popis",
  "antennas.destination.timeline": "Samo vremenska traka antene",
  "antennas.domains": "{count} domene",
  "antennas.done": "Gotovo",
  "antennas.edit": "Uredi antenu",
  "antennas.edit_accounts": "Uredi račune",
  "antennas.exclude_accounts": "Isključi račune",
  "antennas.exclude_domains": "Isključi domene",
  "antennas.exclude_keywords": "Isključi ključne riječi",
  "antennas.exclude_tags": "Isključi oznake",
  "antennas.favourite": "Favoriziraj",
  "antennas.favourite_hint": "Kada otvorite Web klijent na računalu, ova antena se pojavljuje u navigaciji.",
  "antennas.filter_items": "Idi na postavke filtera antene",
  "antennas.filter_not": "Filter Ne",
  "antennas.find_users_to_add": "Pronađi korisnike za dodati",
  "antennas.ignore_reblog": "Isključi pojačanja",
  "antennas.ignore_reblog_hint": "Pojačanja će biti isključena iz detekcije antene.",
  "antennas.in_ltl_mode": "Ova antena je u LTL načinu rada.",
  "antennas.in_stl_mode": "Ova antena je u STL načinu rada.",
  "antennas.keywords": "{count} ključne riječi",
  "antennas.list_selection": "Popis za umetanje",
  "antennas.media_only": "Samo mediji",
  "antennas.media_only_hint": "Samo objave s medijima će biti dodane u antenu.",
  "antennas.memo_insert_home": "Umeće se u početni feed.",
  "antennas.memo_insert_list": "Popis: \"{title}\"",
  "antennas.mode": "Način rada",
  "antennas.mode.filtering": "Filtriranje",
  "antennas.mode.ltl": "Način lokalne vremenske trake",
  "antennas.mode.stl": "Način društvene vremenske trake",
  "antennas.new_antenna_name": "Novi naziv antene",
  "antennas.no_antennas_yet": "Još nema antena.",
  "antennas.no_members_yet": "Još nema članova.",
  "antennas.no_results_found": "Nema pronađenih rezultata.",
  "antennas.remove_member": "Ukloni",
  "antennas.save": "Spremi",
  "antennas.save_to_edit_filtering": "Možete urediti filtriranje nakon spremanja.",
  "antennas.search_placeholder": "Traži ljude koje pratiš",
  "antennas.select.no_options_message": "Prazni popisi",
  "antennas.select.placeholder": "Odaberi popis",
  "antennas.select.set_home": "Postavi početni",
  "antennas.tags": "{count} oznake",
  "antennas.warnings.content_radio": "Istodobno označavanje ključnih riječi i oznaka nije preporučljivo.",
  "antennas.warnings.range_radio": "Istodobno označavanje računa i domene nije preporučljivo.",
  "attachments_list.unprocessed": "(neobrađeno)",
  "audio.hide": "Sakrij audio",
  "block_modal.remote_users_caveat": "Zatražit ćemo od poslužitelja {domain} da poštuje vašu odluku. Međutim, pridržavanje nije zajamčeno jer neki poslužitelji mogu drugačije rješavati blokade. Javne objave mogu i dalje biti vidljive korisnicima koji nisu prijavljeni.",
  "block_modal.show_less": "Prikaži manje",
  "block_modal.show_more": "Prikaži više",
  "block_modal.they_cant_mention": "Ne mogu vas spomenuti niti pratiti.",
  "block_modal.they_cant_see_posts": "Ne mogu vidjeti vaše objave, a vi nećete vidjeti njihove.",
  "block_modal.they_will_know": "Moći će vidjeti da su blokirani.",
  "block_modal.title": "Blokirati korisnika?",
  "block_modal.you_wont_see_mentions": "Nećete vidjeti objave koje ih spominju.",
  "bookmark_categories.add_to_bookmark_categories": "Dodaj {name} u kategorije zabilješki",
  "bookmark_categories.all_bookmarks": "Sve zabilješke",
  "bookmark_categories.bookmark_category_name": "Naziv kategorije zabilješki",
  "bookmark_categories.create": "Kreiraj",
  "bookmark_categories.create_a_bookmark_category_to_organize": "Kreiraj novu kategoriju zabilješki za organiziranje vašeg početnog feeda",
  "bookmark_categories.create_bookmark_category": "Kreiraj kategoriju zabilješki",
  "bookmark_categories.delete": "Izbriši kategoriju",
  "bookmark_categories.edit": "Uredi kategoriju",
  "bookmark_categories.new_bookmark_category_name": "Novi naziv kategorije zabilješki",
  "bookmark_categories.no_bookmark_categories_yet": "Još nema kategorija zabilješki.",
  "bookmark_categories.save": "Spremi",
  "boost_modal.combo": "Možete pritisnuti {combo} da preskočite ovo sljedeći put",
  "boost_modal.reblog": "Pojačati objavu?",
  "boost_modal.undo_reblog": "Opozovi pojačanje objave?",
  "bundle_column_error.copy_stacktrace": "Kopiraj izvješće o pogrešci",
  "bundle_column_error.error.body": "Tražena stranica nije mogla biti prikazana. Možda je uzrok greška u našem kodu ili problem kompatibilnosti preglednika.",
  "bundle_column_error.error.title": "O, ne!",
  "bundle_column_error.network.body": "Došlo je do pogreške prilikom učitavanja ove stranice. To može biti zbog privremenog problema s vašom internetskom vezom ili ovim poslužiteljem.",
  "bundle_column_error.network.title": "Mrežna pogreška",
  "bundle_column_error.retry": "Pokušaj ponovno",
  "bundle_column_error.return": "Vrati se na početak",
  "bundle_column_error.routing.body": "Tražena stranica nije pronađena. Jeste li sigurni da je URL u adresnoj traci točan?",
  "bundle_column_error.routing.title": "404",
  "bundle_modal_error.close": "Zatvori",
  "bundle_modal_error.message": "Nešto je pošlo po zlu prilikom učitavanja ovog zaslona.",
  "bundle_modal_error.retry": "Pokušaj ponovno",
  "circles.add_member": "Dodaj",
  "circles.add_to_circle": "Dodaj u krug",
  "circles.add_to_circles": "Dodaj {name} u krugove",
  "circles.circle_members": "Članovi kruga",
  "circles.circle_members_count": "{count, plural, one {# član} other {# članova}}",
  "circles.circle_name": "Naziv kruga",
  "circles.create": "Kreiraj",
  "circles.create_a_circle_to_organize": "Kreiraj novi krug za organiziranje vašeg početnog feeda",
  "circles.create_circle": "Kreiraj krug",
  "circles.delete": "Izbriši krug",
  "circles.done": "Gotovo",
  "circles.edit": "Uredi krug",
  "circles.find_users_to_add": "Pronađi korisnike za dodati",
  "circles.new_circle_name": "Novi naziv kruga",
  "circles.no_circles_yet": "Još nema krugova.",
  "circles.no_members_yet": "Još nema članova.",
  "circles.no_results_found": "Nema pronađenih rezultata.",
  "circles.remove_member": "Ukloni",
  "circles.save": "Spremi",
  "circles.save_to_edit_member": "Možete urediti članove kruga nakon spremanja.",
  "circles.search_placeholder": "Traži ljude koje pratiš",
  "closed_registrations.other_server_instructions": "Budući da je Mastodon decentraliziran, možete kreirati račun na drugom poslužitelju i i dalje komunicirati s ovim.",
  "closed_registrations_modal.description": "Kreiranje računa na {domain} trenutno nije moguće, ali imajte na umu da vam ne treba račun specifično na {domain} za korištenje Mastodona.",
  "closed_registrations_modal.description_when_reaching_limit": "Nove registracije su trenutno privremeno ograničene. Ili je dostignut maksimalni broj registracija. Kontaktirajte administratora za više informacija ili pričekajte da se ograničenje ukine.",
  "closed_registrations_modal.find_another_server": "Pronađi drugi poslužitelj",
  "closed_registrations_modal.preamble": "Mastodon je decentraliziran, pa bez obzira gdje kreirate svoj račun, moći ćete pratiti i komunicirati s bilo kim na ovom poslužitelju. Možete ga čak i sami hostati!",
  "closed_registrations_modal.title": "Registracija na Mastodonu",
  "column.about": "O nama",
  "column.antenna_members": "Upravljaj članovima antene",
  "column.antennas": "Antene",
  "column.blocks": "Blokirani korisnici",
  "column.bookmark_categories": "Kategorije zabilješki",
  "column.bookmarks": "Zabilješke",
  "column.circle_members": "Upravljaj članovima kruga",
  "column.circles": "Krugovi",
  "column.community": "Lokalna vremenska traka",
  "column.create_antenna": "Kreiraj antenu",
  "column.create_bookmark_category": "Kreiraj kategoriju zabilješki",
  "column.create_circle": "Kreiraj krug",
  "column.create_list": "Kreiraj popis",
  "column.deep_local": "Duboko",
  "column.direct": "Poruke",
  "column.directory": "Pregledaj profile",
  "column.domain_blocks": "Blokirane domene",
  "column.edit_antenna": "Uredi antenu",
  "column.edit_bookmark_category": "Uredi kategoriju zabilješki",
  "column.edit_circle": "Uredi krug",
  "column.edit_list": "Uredi popis",
  "column.emoji_reactions": "Emoji reakcije",
  "column.favourites": "Favoriti",
  "column.firehose": "Live feed",
  "column.follow_requests": "Zahtjevi za praćenjem",
  "column.home": "Početni",
  "column.list_members": "Upravljaj članovima popisa",
  "column.lists": "Popisi",
  "column.local": "Lokalno",
  "column.mutes": "Utišani korisnici",
  "column.notifications": "Obavijesti",
  "column.pins": "Pribilježene objave",
  "column.public": "Federirana vremenska traka",
  "column.reaction_deck": "Reaction deck",
  "column_back_button.label": "Natrag",
  "column_header.hide_settings": "Sakrij postavke",
  "column_header.moveLeft_settings": "Pomakni stupac ulijevo",
  "column_header.moveRight_settings": "Pomakni stupac udesno",
  "column_header.pin": "Pribilježi",
  "column_header.show_settings": "Prikaži postavke",
  "column_header.unpin": "Ukloni pribilježak",
  "column_search.cancel": "Otkaži",
  "community.column_settings.local_only": "Samo lokalno",
  "community.column_settings.media_only": "Samo mediji",
  "community.column_settings.remote_only": "Samo udaljeno",
  "compose.language.change": "Promijeni jezik",
  "compose.language.search": "Traži jezike...",
  "compose.published.body": "Objava je objavljena.",
  "compose.published.open": "Otvori",
  "compose.saved.body": "Objava je spremljena.",
  "compose_form.direct_message_warning_learn_more": "Saznaj više",
  "compose_form.encryption_warning": "Objave na Mastodonu nisu šifrirane od kraja do kraja. Ne dijelite nikakve osjetljive informacije putem Mastodona.",
  "compose_form.hashtag_warning": "Ova objava neće biti navedena ni pod jednom oznakom jer nije javna. Samo javne objave mogu se pretraživati po oznakama.",
  "compose_form.limited_post_warning": "Ograničene objave NE stižu do Misskeya, normalnog Mastodona itd.",
  "compose_form.lock_disclaimer": "Vaš račun nije {locked}. Svatko vas može pratiti da vidi vaše objave samo za sljedbenike.",
  "compose_form.lock_disclaimer.lock": "zaključan",
  "compose_form.markdown.marked": "Markdown je dostupan",
  "compose_form.markdown.unmarked": "Markdown NIJE dostupan",
  "compose_form.mention_warning": "Kada dodate spomen na ograničenu objavu, osoba koju spominjete također može vidjeti ovu objavu.",
  "compose_form.placeholder": "O čemu razmišljaš?",
  "compose_form.poll.duration": "Trajanje ankete",
  "compose_form.poll.multiple": "Višestruki izbor",
  "compose_form.poll.option_placeholder": "Opcija {number}",
  "compose_form.poll.single": "Jedan izbor",
  "compose_form.poll.switch_to_multiple": "Promijeni anketu da dopušta višestruki izbor",
  "compose_form.poll.switch_to_single": "Promijeni anketu da dopušta jedan izbor",
  "compose_form.poll.type": "Stil",
  "compose_form.publish": "Objavi",
  "compose_form.reply": "Odgovori",
  "compose_form.save_changes": "Ažuriraj",
  "compose_form.searchability_warning": "Mogućnost pretraživanja samo za sebe nije dostupna na drugim mastodon poslužiteljima. Drugi mogu pretraživati vašu objavu.",
  "compose_form.spoiler.marked": "Ukloni upozorenje o sadržaju",
  "compose_form.spoiler.unmarked": "Dodaj upozorenje o sadržaju",
  "compose_form.spoiler_placeholder": "Upozorenje o sadržaju (opcionalno)",
  "confirmation_modal.cancel": "Otkaži",
  "confirmations.block.confirm": "Blokiraj",
  "confirmations.delete.confirm": "Izbriši",
  "confirmations.delete.message": "Jeste li sigurni da želite izbrisati ovu objavu?",
  "confirmations.delete.title": "Izbrisati objavu?",
  "confirmations.delete_antenna.confirm": "Izbriši",
  "confirmations.delete_antenna.message": "Jeste li sigurni da želite trajno izbrisati ovu antenu?",
  "confirmations.delete_antenna.title": "Izbrisati antenu?",
  "confirmations.delete_bookmark_category.confirm": "Izbriši",
  "confirmations.delete_bookmark_category.message": "Jeste li sigurni da želite trajno izbrisati ovu kategoriju?",
  "confirmations.delete_bookmark_category.title": "Izbrisati kategoriju zabilješki?",
  "confirmations.delete_circle.confirm": "Izbriši",
  "confirmations.delete_circle.message": "Jeste li sigurni da želite trajno izbrisati ovaj krug?",
  "confirmations.delete_circle.title": "Izbrisati krug?",
  "confirmations.delete_list.confirm": "Izbriši",
  "confirmations.delete_list.message": "Jeste li sigurni da želite trajno izbrisati ovaj popis?",
  "confirmations.delete_list.title": "Izbrisati popis?",
  "confirmations.discard_draft.confirm": "Odbaci i nastavi",
  "confirmations.discard_draft.edit.cancel": "Nastavi uređivati",
  "confirmations.discard_draft.edit.message": "Nastavak će odbaciti sve promjene koje ste napravili na objavi koju trenutno uređujete.",
  "confirmations.discard_draft.edit.title": "Odbaciti promjene na vašoj objavi?",
  "confirmations.discard_draft.post.cancel": "Nastavi s nacrtom",
  "confirmations.discard_draft.post.message": "Nastavak će odbaciti objavu koju trenutno pišete.",
  "confirmations.discard_draft.post.title": "Odbaciti vašu objavu u nastajanju?",
  "confirmations.discard_edit_media.confirm": "Odbaci",
  "confirmations.discard_edit_media.message": "Imate nespremljene promjene na opisu medija ili pregledu, odbaciti ih svejedno?",
  "confirmations.follow_to_list.confirm": "Prati i dodaj na popis",
  "confirmations.follow_to_list.message": "Morate pratiti {name} da biste ga dodali na popis.",
  "confirmations.follow_to_list.title": "Pratiti korisnika?",
  "confirmations.logout.confirm": "Odjavi se",
  "confirmations.logout.message": "Jeste li sigurni da se želite odjaviti?",
  "confirmations.logout.title": "Odjaviti se?",
  "confirmations.missing_alt_text.confirm": "Dodaj alternativni tekst",
  "confirmations.missing_alt_text.message": "Vaša objava sadrži medije bez alternativnog teksta. Dodavanje opisa pomaže da vaš sadržaj bude pristupačan većem broju ljudi.",
  "confirmations.missing_alt_text.secondary": "Objavi svejedno",
  "confirmations.missing_alt_text.title": "Dodati alternativni tekst?",
  "confirmations.mute.confirm": "Utišaj",
  "confirmations.quiet_post_quote_info.dismiss": "Ne podsjećaj me opet",
  "confirmations.quiet_post_quote_info.got_it": "Shvaćam",
  "confirmations.quiet_post_quote_info.message": "Kada citirate tihu javnu objavu, vaša objava će biti skrivena od trendovskih vremenskih traka.",
  "confirmations.quiet_post_quote_info.title": "Citiranje tihih javnih objava",
  "confirmations.redraft.confirm": "Izbriši & ponovno napiši",
  "confirmations.redraft.message": "Jeste li sigurni da želite izbrisati ovu objavu i ponovno je napisati? Favoriti i pojačanja će biti izgubljeni, a odgovori na izvornu objavu će ostati siročad.",
  "confirmations.redraft.title": "Izbrisati & ponovno napisati objavu?",
  "confirmations.remove_from_followers.confirm": "Ukloni sljedbenika",
  "confirmations.remove_from_followers.message": "{name} će prestati pratiti vas. Jeste li sigurni da želite nastaviti?",
  "confirmations.remove_from_followers.title": "Ukloniti sljedbenika?",
  "confirmations.revoke_quote.confirm": "Ukloni objavu",
  "confirmations.revoke_quote.message": "Ova radnja se ne može poništiti.",
  "confirmations.revoke_quote.title": "Ukloniti objavu?",
  "confirmations.unblock.confirm": "Odblokiraj",
  "confirmations.unblock.title": "Odblokirati {name}?",
  "confirmations.unfollow.confirm": "Prestani pratiti",
  "confirmations.unfollow.message": "Jeste li sigurni da želite prestati pratiti {name}?",
  "confirmations.unfollow.title": "Prestati pratiti {name}?",
  "confirmations.withdraw_request.confirm": "Povuci zahtjev",
  "confirmations.withdraw_request.title": "Povući zahtjev za praćenjem {name}?",
  "content_warning.hide": "Sakrij objavu",
  "content_warning.show": "Prikaži svejedno",
  "content_warning.show_more": "Prikaži više",
  "conversation.delete": "Izbriši razgovor",
  "conversation.mark_as_read": "Označi kao pročitano",
  "conversation.open": "Pogledaj razgovor",
  "conversation.with": "S {names}",
  "copy_icon_button.copied": "Kopirano u međuspremnik",
  "copypaste.copied": "Kopirano",
  "copypaste.copy_to_clipboard": "Kopiraj u međuspremnik",
  "directory.federated": "Prikaži sa poznatih servera",
  "directory.local": "Samo sa {domain}",
  "directory.new_arrivals": "Novi dolasci",
  "directory.recently_active": "Nedavno aktivni",
  "disabled_account_banner.account_settings": "Postavke računa",
  "disabled_account_banner.text": "Vaš račun {disabledAccount} je trenutno onemogućen.",
  "dismissable_banner.community_timeline": "Ovo su najnovije javne objave ljudi čiji su računi hostani na {domain}.",
  "dismissable_banner.dismiss": "Odbaci",
  "dismissable_banner.public_timeline": "Ovo su najnovije javne objave ljudi iz fediverzuma koje ljudi na {domain} prate.",
  "domain_block_modal.block": "Blokiraj poslužitelj",
  "domain_block_modal.block_account_instead": "Umjesto toga blokiraj @{name}",
  "domain_block_modal.they_can_interact_with_old_posts": "Ljudi s ovog poslužitelja mogu komunicirati s vašim starim objavama.",
  "domain_block_modal.they_cant_follow": "Nitko s ovog poslužitelja vas ne može pratiti.",
  "domain_block_modal.they_wont_know": "Neće znati da su blokirani.",
  "domain_block_modal.title": "Blokirati domenu?",
  "domain_block_modal.you_will_lose_num_followers": "Izgubit ćete {followersCount, plural, one {{followersCountDisplay} sljedbenika} other {{followersCountDisplay} sljedbenika}} i {followingCount, plural, one {{followingCountDisplay} osobu koju pratite} other {{followingCountDisplay} osoba koje pratite}}.",
  "domain_block_modal.you_will_lose_relationships": "Izgubit ćete sve sljedbenike i ljude koje pratite s ovog poslužitelja.",
  "domain_block_modal.you_wont_see_posts": "Nećete vidjeti objave ili obavijesti od korisnika na ovom poslužitelju.",
  "domain_pill.activitypub_lets_connect": "Omogućuje vam povezivanje i interakciju s ljudima ne samo na Mastodonu, već i preko različitih društvenih aplikacija.",
  "domain_pill.activitypub_like_language": "ActivityPub je poput jezika koji Mastodon govori s drugim društvenim mrežama.",
  "domain_pill.server": "Poslužitelj",
  "domain_pill.their_handle": "Njihov handle:",
  "domain_pill.their_server": "Njihov digitalni dom, gdje žive sve njihove objave.",
  "domain_pill.their_server_software": "Ovaj poslužitelj koristi <software>nepoznati</software> softver, ali možete pregledavati objave i sudjelovati u razgovorima baš kao i drugi korisnici.",
  "domain_pill.their_username": "Njihov jedinstveni identifikator na njihovom poslužitelju. Moguće je pronaći korisnike s istim korisničkim imenom na različitim poslužiteljima.",
  "domain_pill.username": "Korisničko ime",
  "domain_pill.whats_in_a_handle": "Što je handle?",
  "domain_pill.who_they_are": "Budući da handleovi govore tko je netko i gdje se nalazi, možete komunicirati s ljudima diljem društvenog weba <button>platformi pokretanih ActivityPubom</button>.",
  "domain_pill.who_you_are": "Budući da vaš handle govori tko ste i gdje se nalazite, ljudi mogu komunicirati s vama diljem društvenog weba <button>platformi pokretanih ActivityPubom</button>.",
  "domain_pill.your_handle": "Vaš handle:",
  "domain_pill.your_server": "Vaš digitalni dom, gdje žive sve vaše objave. Ne sviđa vam se ovaj? Prenesite se na druge poslužitelje u bilo kojem trenutku i ponesite svoje sljedbenike sa sobom.",
  "domain_pill.your_username": "Vaš jedinstveni identifikator na ovom poslužitelju. Moguće je pronaći korisnike s istim korisničkim imenom na različitim poslužiteljima.",
  "dropdown.empty": "Odaberi opciju",
  "embed.instructions": "Ugradite ovu objavu na svoju web stranicu kopiranjem koda ispod.",
  "embed.preview": "Evo kako će izgledati:",
  "emoji_button.activity": "Aktivnost",
  "emoji_button.clear": "Očisti",
  "emoji_button.custom": "Prilagođeno",
  "emoji_button.flags": "Zastave",
  "emoji_button.food": "Hrana i piće",
  "emoji_button.label": "Umetni emoji",
  "emoji_button.nature": "Priroda",
  "emoji_button.not_found": "Nema pronađenih emojija",
  "emoji_button.objects": "Predmeti",
  "emoji_button.people": "Ekipa",
  "emoji_button.recent": "Često korišteno",
  "emoji_button.search": "Traži...",
  "emoji_button.search_results": "Rezultati pretraživanja",
  "emoji_button.symbols": "Simboli",
  "emoji_button.travel": "Putovanja i mjesta",
  "empty_column.account_featured.me": "Još niste ništa istaknuli. Jeste li znali da možete istaknuti oznake koje najviše koristite, pa čak i račune svojih prijatelja na svom profilu?",
  "empty_column.account_featured.other": "{acct} još nije ništa istaknuo/la. Jeste li znali da možete istaknuti oznake koje najviše koristite, pa čak i račune svojih prijatelja na svom profilu?",
  "empty_column.account_featured_other.unknown": "Ovaj račun još nije ništa istaknuo.",
  "empty_column.account_hides_collections": "Ovaj korisnik je odlučio ne učiniti ovu informaciju dostupnom",
  "empty_column.account_suspended": "Račun suspendiran",
  "empty_column.account_timeline": "Ovdje nema objava!",
  "empty_column.account_unavailable": "Profil nedostupan",
  "empty_column.antenna": "Još nema ničega u ovoj anteni. Kada članovi ovog popisa objave nove statuse, pojavit će se ovdje.",
  "empty_column.blocks": "Još niste blokirali nijednog korisnika.",
  "empty_column.bookmarked_statuses": "Još nemate nijednu objavu u zabilješkama. Kada neku zabilježite, pojavit će se ovdje.",
  "empty_column.circle_statuses": "Još nemate nijednu objavu u krugu. Kada objavite nešto u krugu, pojavit će se ovdje.",
  "empty_column.community": "Lokalna vremenska traka je prazna. Napišite nešto javno da pokrenete stvari!",
  "empty_column.direct": "Još nemate nijedan privatni spomen. Kada pošaljete ili primite jedan, pojavit će se ovdje.",
  "empty_column.domain_blocks": "Još nema blokiranih domena.",
  "empty_column.emoji_reacted_statuses": "Još nemate nijednu objavu s emoji reakcijom. Kada reagirate emojijem na objavu, pojavit će se ovdje.",
  "empty_column.emoji_reactions": "Još nitko nije reagirao emojijem na ovu objavu. Kada netko to učini, pojavit će se ovdje.",
  "empty_column.explore_statuses": "Trenutno ništa nije u trendu. Provjerite ponovno kasnije!",
  "empty_column.favourited_statuses": "Još nemate nijednu omiljenu objavu. Kada neku omilite, pojavit će se ovdje.",
  "empty_column.favourites": "Još nitko nije omilio ovu objavu. Kada netko to učini, pojavit će se ovdje.",
  "empty_column.follow_requests": "Još nemate nijedan zahtjev za praćenjem. Kada primite jedan, pojavit će se ovdje.",
  "empty_column.followed_tags": "Još niste pratili nijednu oznaku. Kada to učinite, pojavit će se ovdje.",
  "empty_column.hashtag": "Još nema ničega u ovoj oznaci.",
  "empty_column.home": "Vaša početna vremenska traka je prazna! Pratite više ljudi da je napunite.",
  "empty_column.list": "Još nema ničega na ovom popisu. Kada članovi ovog popisa objave nove objave, pojavit će se ovdje.",
  "empty_column.mentioned_users": "Nitko nije spomenut ovom objavom.",
  "empty_column.mutes": "Još niste utišali nijednog korisnika.",
  "empty_column.notification_requests": "Sve je čisto! Ovdje nema ničega. Kada primate nove obavijesti, pojavit će se ovdje prema vašim postavkama.",
  "empty_column.notifications": "Još nemate nijednu obavijest. Kada drugi ljudi komuniciraju s vama, vidjet ćete to ovdje.",
  "empty_column.public": "Ovdje nema ničega! Napišite nešto javno ili ručno pratite korisnike s drugih poslužitelja da popunite.",
  "empty_column.status_references": "Još nitko nije povezao ovu objavu. Kada netko to učini, pojavit će se ovdje.",
  "error.unexpected_crash.explanation": "Zbog greške u našem kodu ili problema kompatibilnosti preglednika, ova stranica nije mogla biti ispravno prikazana.",
  "error.unexpected_crash.explanation_addons": "Ova stranica nije mogla biti ispravno prikazana. Ovu pogrešku vjerojatno uzrokuju dodaci preglednika ili alati za automatski prijevod.",
  "error.unexpected_crash.next_steps": "Pokušajte osvježiti stranicu. Ako to ne pomogne, možda ćete i dalje moći koristiti Mastodon putem drugog preglednika ili nativne aplikacije.",
  "error.unexpected_crash.next_steps_addons": "Pokušajte ih onemogućiti i osvježiti stranicu. Ako to ne pomogne, možda ćete i dalje moći koristiti Mastodon putem drugog preglednika ili nativne aplikacije.",
  "errors.unexpected_crash.copy_stacktrace": "Kopiraj stacktrace u međuspremnik",
  "errors.unexpected_crash.report_issue": "Prijavi problem",
  "explore.suggested_follows": "Ekipa",
  "explore.title": "Popularno",
  "explore.trending_links": "Vijesti",
  "explore.trending_statuses": "Objave",
  "explore.trending_tags": "Oznake",
  "featured_carousel.header": "{count, plural, one {Pribilježena objava} other {Pribilježene objave}}",
  "featured_carousel.next": "Sljedeće",
  "featured_carousel.post": "Objava",
  "featured_carousel.previous": "Prethodno",
  "featured_carousel.slide": "{index} od {total}",
  "filter_modal.added.context_mismatch_explanation": "Ova kategorija filtera ne primjenjuje se na kontekst u kojem ste pristupili ovoj objavi. Ako želite da se objava filtrira i u ovom kontekstu, morat ćete urediti filter.",
  "filter_modal.added.context_mismatch_title": "Nepodudaranje konteksta!",
  "filter_modal.added.expired_explanation": "Ova kategorija filtera je istekla, morat ćete promijeniti datum isteka da bi se primjenjivala.",
  "filter_modal.added.expired_title": "Filter je istekao!",
  "filter_modal.added.review_and_configure": "Za pregled i daljnju konfiguraciju ove kategorije filtera, idite na {settings_link}.",
  "filter_modal.added.review_and_configure_title": "Postavke filtera",
  "filter_modal.added.settings_link": "stranicu s postavkama",
  "filter_modal.added.short_explanation": "Ova objava je dodana u sljedeću kategoriju filtera: {title}.",
  "filter_modal.added.title": "Filter dodan!",
  "filter_modal.select_filter.context_mismatch": "ne primjenjuje se na ovaj kontekst",
  "filter_modal.select_filter.expired": "isteklo",
  "filter_modal.select_filter.prompt_new": "Nova kategorija: {name}",
  "filter_modal.select_filter.search": "Traži ili kreiraj",
  "filter_modal.select_filter.subtitle": "Koristi postojeću kategoriju ili kreiraj novu",
  "filter_modal.select_filter.title": "Filtriraj ovu objavu",
  "filter_modal.title.status": "Filtriraj objavu",
  "filter_warning.matches_filter": "Odgovara filteru \"<span>{title}</span>\"",
  "filtered_notifications_banner.pending_requests": "Od {count, plural, =0 {nikoga} one {jedne osobe} other {# ljudi}} koje možda poznajete",
  "filtered_notifications_banner.title": "Filtrirane obavijesti",
  "firehose.all": "Sve",
  "firehose.local": "Ovaj poslužitelj",
  "firehose.remote": "Drugi poslužitelji",
  "follow_request.authorize": "Odobri",
  "follow_request.reject": "Odbij",
  "follow_requests.unlocked_explanation": "Iako vaš račun nije zaključan, osoblje {domain} je smatralo da biste možda željeli ručno pregledati zahtjeve za praćenjem od ovih računa.",
  "follow_suggestions.curated_suggestion": "Izbor osoblja",
  "follow_suggestions.dismiss": "Ne prikazuj opet",
  "follow_suggestions.featured_longer": "Ručno odabrano od strane tima {domain}",
  "follow_suggestions.friends_of_friends_longer": "Popularno među ljudima koje pratite",
  "follow_suggestions.hints.featured": "Ovaj profil je ručno odabrao tim {domain}.",
  "follow_suggestions.hints.friends_of_friends": "Ovaj profil je popularan među ljudima koje pratite.",
  "follow_suggestions.hints.most_followed": "Ovaj profil je jedan od najpraćenijih na {domain}.",
  "follow_suggestions.hints.most_interactions": "Ovaj profil je nedavno dobivao puno pažnje na {domain}.",
  "follow_suggestions.hints.similar_to_recently_followed": "Ovaj profil je sličan profilima koje ste nedavno najviše pratili.",
  "follow_suggestions.personalized_suggestion": "Personalizirani prijedlog",
  "follow_suggestions.popular_suggestion": "Popularni prijedlog",
  "follow_suggestions.popular_suggestion_longer": "Popularno na {domain}",
  "follow_suggestions.similar_to_recently_followed_longer": "Slično profilima koje ste nedavno pratili",
  "follow_suggestions.view_all": "Pogledaj sve",
  "follow_suggestions.who_to_follow": "Koga pratiti",
  "followed_tags": "Praćene oznake",
  "footer.about": "O nama",
  "footer.directory": "Imenik profila",
  "footer.get_app": "Preuzmi aplikaciju",
  "footer.keyboard_shortcuts": "Tipkovni prečaci",
  "footer.privacy_policy": "Pravila privatnosti",
  "footer.source_code": "Pogledaj izvorni kod",
  "footer.status": "Status",
  "footer.terms_of_service": "Uvjeti korištenja",
  "generic.saved": "Spremljeno",
  "getting_started.heading": "Početak rada",
  "hashtag.admin_moderation": "Otvori sučelje moderiranja za #{name}",
  "hashtag.browse": "Pregledaj objave u #{hashtag}",
  "hashtag.browse_from_account": "Pregledaj objave od @{name} u #{hashtag}",
  "hashtag.column_header.tag_mode.all": "i {additional}",
  "hashtag.column_header.tag_mode.any": "ili {additional}",
  "hashtag.column_header.tag_mode.none": "bez {additional}",
  "hashtag.column_settings.select.no_options_message": "Nema pronađenih prijedloga",
  "hashtag.column_settings.select.placeholder": "Unesi oznake…",
  "hashtag.column_settings.tag_mode.all": "Sve od ovoga",
  "hashtag.column_settings.tag_mode.any": "Bilo koje od ovoga",
  "hashtag.column_settings.tag_mode.none": "Ništa od ovoga",
  "hashtag.column_settings.tag_toggle": "Uključi dodatne oznake za ovaj stupac",
  "hashtag.counter_by_accounts": "{count, plural, one {{counter} sudionik} other {{counter} sudionika}}",
  "hashtag.counter_by_uses": "{count, plural, one {{counter} objava} other {{counter} objava}}",
  "hashtag.counter_by_uses_today": "{count, plural, one {{counter} objava} other {{counter} objava}} danas",
  "hashtag.feature": "Istakni na profilu",
  "hashtag.follow": "Prati oznaku",
  "hashtag.mute": "Utišaj #{hashtag}",
  "hashtag.unfeature": "Ne isticati na profilu",
  "hashtag.unfollow": "Prestani pratiti oznaku",
  "hashtags.and_other": "…i {count, plural, other {# još}}",
  "hints.profiles.followers_may_be_missing": "Pratitelji za ovaj profil mogu nedostajati.",
  "hints.profiles.follows_may_be_missing": "Pratitelji za ovaj profil mogu nedostajati.",
  "hints.profiles.posts_may_be_missing": "Neke objave s ovog profila mogu nedostajati.",
  "hints.profiles.see_more_followers": "Vidi više sljedbenika na {domain}",
  "hints.profiles.see_more_follows": "Vidi više pratitelja na {domain}",
  "hints.profiles.see_more_posts": "Vidi više objava na {domain}",
  "hints.threads.replies_may_be_missing": "Odgovori s drugih servera mogu nedostajati.",
  "hints.threads.see_more": "Vidi više odgovora na {domain}",
  "home.column_settings.show_quotes": "Prikaži citate",
  "home.column_settings.show_reblogs": "Prikaži pojačanja",
  "home.column_settings.show_replies": "Prikaži odgovore",
  "home.hide_announcements": "Sakrij obavijesti",
  "home.pending_critical_update.body": "Ažurirajte svoj Mastodon poslužitelj što je prije moguće!",
  "home.pending_critical_update.link": "Vidi ažuriranja",
  "home.pending_critical_update.title": "Dostupno kritično sigurnosno ažuriranje!",
  "home.show_announcements": "Prikaži obavijesti",
  "ignore_notifications_modal.disclaimer": "Mastodon ne može obavijestiti korisnike da ste zanemarili njihove obavijesti. Zanemarivanje obavijesti neće zaustaviti slanje samih poruka.",
  "ignore_notifications_modal.filter_instead": "Umjesto toga filtriraj",
  "ignore_notifications_modal.filter_to_act_users": "I dalje ćete moći prihvatiti, odbiti ili prijaviti korisnike",
  "ignore_notifications_modal.filter_to_avoid_confusion": "Filtriranje pomaže izbjeći potencijalnu zbrku",
  "ignore_notifications_modal.filter_to_review_separately": "Možete zasebno pregledati filtrirane obavijesti",
  "ignore_notifications_modal.ignore": "Zanemari obavijesti",
  "ignore_notifications_modal.limited_accounts_title": "Zanemariti obavijesti od moderiranih računa?",
  "ignore_notifications_modal.new_accounts_title": "Zanemariti obavijesti od novih računa?",
  "ignore_notifications_modal.not_followers_title": "Zanemariti obavijesti od ljudi koji vas ne prate?",
  "ignore_notifications_modal.not_following_title": "Zanemariti obavijesti od ljudi koje ne pratite?",
  "ignore_notifications_modal.private_mentions_title": "Zanemariti obavijesti od neželjenih privatnih spomena?",
  "info_button.label": "Pomoć",
  "info_button.what_is_alt_text": "<h1>Što je alternativni tekst?</h1> <p>Alternativni tekst pruža opise slika za osobe s oštećenjem vida, sporim internetskim vezama ili one koje traže dodatni kontekst.</p> <p>Možete poboljšati pristupačnost i razumijevanje za sve pisanjem jasnog, sažetog i objektivnog alternativnog teksta.</p> <ul> <li>Obuhvatite važne elemente</li> <li>Sažmite tekst na slikama</li> <li>Koristite uobičajenu rečenicu</li> <li>Izbjegavajte redundantne informacije</li> <li>Usredotočite se na trendove i ključne nalaze u složenim vizualima (kao što su dijagrami ili karte)</li> </ul>",
  "interaction_modal.action": "Da biste komunicirali s objavom {name}, morate se prijaviti na svoj račun na mastodon poslužitelju koji koristite.",
  "interaction_modal.action.favourite": "Da biste nastavili, morate favorizirati sa svog računa.",
  "interaction_modal.action.follow": "Da biste nastavili, morate pratiti sa svog računa.",
  "interaction_modal.action.reblog": "Da biste nastavili, morate podići sa svog računa.",
  "interaction_modal.action.reply": "Da biste nastavili, morate odgovoriti sa svog računa.",
  "interaction_modal.action.vote": "Da biste nastavili, morate glasati sa svog računa.",
  "interaction_modal.go": "Idi",
  "interaction_modal.no_account_yet": "Još nemate račun?",
  "interaction_modal.on_another_server": "Na drugom poslužitelju",
  "interaction_modal.on_this_server": "Na ovom poslužitelju",
  "interaction_modal.title": "Prijavite se za nastavak",
  "interaction_modal.title.follow": "Prati {name}",
  "interaction_modal.username_prompt": "Npr. {example}",
  "intervals.full.days": "{number, plural, one {# dan} other {# dana}}",
  "intervals.full.hours": "{number, plural, one {# sat} other {# sati}}",
  "intervals.full.minutes": "{number, plural, one {# minuta} other {# minuta}}",
  "keyboard_shortcuts.back": "Navigiraj natrag",
  "keyboard_shortcuts.blocked": "Otvori popis blokiranih korisnika",
  "keyboard_shortcuts.boost": "Pojačaj objavu",
  "keyboard_shortcuts.column": "Fokusiraj stupac",
  "keyboard_shortcuts.compose": "Fokusiraj područje za pisanje",
  "keyboard_shortcuts.description": "Opis",
  "keyboard_shortcuts.direct": "za otvaranje stupca privatnih spomena",
  "keyboard_shortcuts.down": "Pomakni se dolje na popisu",
  "keyboard_shortcuts.emoji_reactions": "za otvaranje popisa žigova",
  "keyboard_shortcuts.enter": "Otvori objavu",
  "keyboard_shortcuts.favourite": "Omilji objavu",
  "keyboard_shortcuts.favourites": "Otvori popis favorita",
  "keyboard_shortcuts.federated": "Otvori federiranu vremensku traku",
  "keyboard_shortcuts.heading": "Tipkovni prečaci",
  "keyboard_shortcuts.home": "Otvori početnu vremensku traku",
  "keyboard_shortcuts.hotkey": "Prečac",
  "keyboard_shortcuts.legend": "Prikaži ovu legendu",
  "keyboard_shortcuts.load_more": "Fokusiraj gumb \"Učitaj više\"",
  "keyboard_shortcuts.local": "Otvori lokalnu vremensku traku",
  "keyboard_shortcuts.mention": "Spomeni autora",
  "keyboard_shortcuts.muted": "Otvori popis utišanih korisnika",
  "keyboard_shortcuts.my_profile": "Otvori svoj profil",
  "keyboard_shortcuts.notifications": "Otvori stupac obavijesti",
  "keyboard_shortcuts.open_media": "Otvori medij",
  "keyboard_shortcuts.pinned": "Otvori popis pribilježenih objava",
  "keyboard_shortcuts.profile": "Otvori profil autora",
  "keyboard_shortcuts.quote": "Citiraj objavu",
  "keyboard_shortcuts.reply": "Odgovori na objavu",
  "keyboard_shortcuts.requests": "Otvori popis zahtjeva za praćenjem",
  "keyboard_shortcuts.search": "Fokusiraj traku za pretraživanje",
  "keyboard_shortcuts.spoilers": "Prikaži/sakrij CW polje",
  "keyboard_shortcuts.start": "Otvori stupac \"započni\"",
  "keyboard_shortcuts.toggle_hidden": "Prikaži/sakrij tekst iza CW",
  "keyboard_shortcuts.toggle_sensitivity": "Prikaži/sakrij medij",
  "keyboard_shortcuts.toot": "Započni novu objavu",
  "keyboard_shortcuts.translate": "za prevođenje objave",
  "keyboard_shortcuts.unfocus": "Ukloni fokus s područja za pisanje/pretraživanje",
  "keyboard_shortcuts.up": "Pomakni se gore na popisu",
  "learn_more_link.got_it": "Shvaćam",
  "learn_more_link.learn_more": "Saznaj više",
  "lightbox.close": "Zatvori",
  "lightbox.next": "Sljedeće",
  "lightbox.previous": "Prethodno",
  "lightbox.zoom_in": "Zumiraj na stvarnu veličinu",
  "lightbox.zoom_out": "Zumiraj da stane",
  "limited_account_hint.action": "Svejedno prikaži profil",
  "limited_account_hint.title": "Ovaj profil su sakrili moderatori {domain}.",
  "link_preview.author": "Autor: {name}",
  "link_preview.more_from_author": "Više od {name}",
  "link_preview.shares": "{count, plural, one {{counter} objava} other {{counter} objava}}",
  "lists.add_member": "Dodaj",
  "lists.add_to_list": "Dodaj na popis",
  "lists.add_to_lists": "Dodaj {name} na popise",
  "lists.antennas": "Povezane antene:",
  "lists.create": "Kreiraj",
  "lists.create_a_list_to_organize": "Kreiraj novi popis za organiziranje vašeg početnog feeda",
  "lists.create_list": "Kreiraj popis",
  "lists.delete": "Izbriši popis",
  "lists.done": "Gotovo",
  "lists.edit": "Uredi popis",
  "lists.exclusive": "Sakrij članove u Početnom",
  "lists.exclusive_hint": "Ako je netko na ovom popisu, sakrijte ga u svom Početnom feedu kako ne biste vidjeli njegove objave dva puta.",
  "lists.favourite": "Favoriziraj",
  "lists.favourite_hint": "Kada otvorite Web klijent na računalu, ovaj popis se pojavljuje u navigaciji.",
  "lists.find_users_to_add": "Pronađi korisnike za dodati",
  "lists.list_members_count": "{count, plural, one {# član} other {# članova}}",
  "lists.list_name": "Naziv popisa",
  "lists.memo_related_antenna": "Antena: \"{title}\"",
  "lists.new_list_name": "Novi naziv popisa",
  "lists.no_lists_yet": "Još nema popisa.",
  "lists.no_members_yet": "Još nema članova.",
  "lists.no_results_found": "Nema pronađenih rezultata.",
  "lists.notify": "Obavijesti o ovim objavama",
  "lists.notify_hint": "Obavijesti kada se doda nova objava.",
  "lists.remove_member": "Ukloni",
  "lists.replies_policy.followed": "Bilo koji praćeni korisnik",
  "lists.replies_policy.list": "Članovi popisa",
  "lists.replies_policy.none": "Nitko",
  "lists.save": "Spremi",
  "lists.save_to_edit_member": "Možete urediti članove popisa nakon spremanja.",
  "lists.search": "Traži",
  "lists.show_replies_to": "Uključi odgovore članova popisa za",
  "load_pending": "{count, plural, one {# nova stavka} other {# nove stavke}}",
  "loading_indicator.label": "Učitavanje…",
  "media_gallery.hide": "Sakrij",
  "moved_to_account_banner.text": "Vaš račun {disabledAccount} je trenutno onemogućen jer ste se preselili na {movedToAccount}.",
  "mute_modal.hide_from_notifications": "Sakrij od obavijesti",
  "mute_modal.hide_options": "Sakrij opcije",
  "mute_modal.indefinite": "Dok ih ne poništim utišavanje",
  "mute_modal.show_options": "Prikaži opcije",
  "mute_modal.they_can_mention_and_follow": "Mogu vas spomenuti i pratiti, ali vi ih nećete vidjeti.",
  "mute_modal.they_wont_know": "Neće znati da su utišani.",
  "mute_modal.title": "Utišati korisnika?",
  "mute_modal.you_wont_see_mentions": "Nećete vidjeti objave koje ih spominju.",
  "mute_modal.you_wont_see_posts": "Oni i dalje mogu vidjeti vaše objave, ali vi nećete vidjeti njihove.",
  "navigation_bar.about": "O nama",
  "navigation_bar.account_settings": "Lozinka i sigurnost",
  "navigation_bar.administration": "Administracija",
  "navigation_bar.advanced_interface": "Otvori u naprednom web sučelju",
  "navigation_bar.antennas": "Antena",
  "navigation_bar.automated_deletion": "Automatsko brisanje objava",
  "navigation_bar.blocks": "Blokirani korisnici",
  "navigation_bar.bookmarks": "Zabilješke",
  "navigation_bar.circles": "Krugovi",
  "navigation_bar.direct": "Poruke",
  "navigation_bar.domain_blocks": "Blokirane domene",
  "navigation_bar.emoji_reactions": "Emoji reakcije",
  "navigation_bar.favourites": "Favoriti",
  "navigation_bar.filters": "Utišane riječi",
  "navigation_bar.follow_requests": "Zahtjevi za praćenjem",
  "navigation_bar.followed_tags": "Praćene oznake",
  "navigation_bar.follows_and_followers": "Pratitelji i sljedbenici",
  "navigation_bar.import_export": "Uvoz i izvoz",
  "navigation_bar.lists": "Popisi",
  "navigation_bar.live_feed_local": "Live feed (lokalni)",
  "navigation_bar.live_feed_public": "Live feed (javni)",
  "navigation_bar.logout": "Odjava",
  "navigation_bar.moderation": "Moderiranje",
  "navigation_bar.more": "Više",
  "navigation_bar.mutes": "Utišani korisnici",
  "navigation_bar.opened_in_classic_interface": "Objave, računi i druge specifične stranice otvaraju se prema zadanim postavkama u klasičnom web sučelju.",
  "navigation_bar.preferences": "Postavke",
  "navigation_bar.privacy_and_reach": "Privatnost i doseg",
  "navigation_bar.reaction_deck": "Reaction deck",
  "navigation_bar.search": "Traži",
  "navigation_bar.search_trends": "Traži / Trending",
  "navigation_panel.collapse_followed_tags": "Sažmi izbornik praćenih oznaka",
  "navigation_panel.collapse_lists": "Sažmi izbornik popisa",
  "navigation_panel.expand_followed_tags": "Proširi izbornik praćenih oznaka",
  "navigation_panel.expand_lists": "Proširi izbornik popisa",
  "not_signed_in_indicator.not_signed_in": "Morate se prijaviti da pristupite ovom resursu.",
  "notification.admin.report": "{name} je prijavio/la {target}",
  "notification.admin.report_account": "{name} je prijavio/la {count, plural, one {jednu objavu} other {# objave}} od {target} za {category}",
  "notification.admin.report_account_other": "{name} je prijavio/la {count, plural, one {jednu objavu} other {# objava}} od {target}",
  "notification.admin.report_statuses": "{name} je prijavio/la {target} za {category}",
  "notification.admin.report_statuses_other": "{name} je prijavio/la {target}",
  "notification.admin.sign_up": "{name} se prijavio/la",
  "notification.admin.sign_up.name_and_others": "{name} i {count, plural, one {# drugi} other {# drugih}} su se prijavili",
  "notification.annual_report.message": "Vaš {year} #Wrapstodon čeka! Otkrijte vrhunce svoje godine i nezaboravne trenutke na Mastodonu!",
  "notification.annual_report.view": "Pogledaj #Wrapstodon",
  "notification.emoji_reaction": "{name} je reagirao/la emojijem na vašu objavu",
  "notification.emoji_reaction.name_and_others_with_link": "{name} i <a>{count, plural, one {# drugi} other {# drugih}}</a> su reagirali emojijem na vašu objavu",
  "notification.favourite": "{name} je omilio/la vašu objavu",
  "notification.favourite.name_and_others_with_link": "{name} i <a>{count, plural, one {# drugi} other {# drugih}}</a> su omilili vašu objavu",
  "notification.favourite_pm": "{name} je omilio/la vaš privatni spomen",
  "notification.favourite_pm.name_and_others_with_link": "{name} i <a>{count, plural, one {# drugi} other {# drugih}}</a> su omilili vaš privatni spomen",
  "notification.follow": "{name} vas je zapratio/la",
  "notification.follow.name_and_others": "{name} i <a>{count, plural, one {# drugi} other {# drugih}}</a> su vas zapratili",
  "notification.follow_request": "{name} je zatražio/la da vas prati",
  "notification.follow_request.name_and_others": "{name} i {count, plural, one {# drugi} other {# drugih}} su zatražili da vas prate",
  "notification.label.mention": "Spomen",
  "notification.label.private_mention": "Privatni spomen",
  "notification.label.private_reply": "Privatni odgovor",
  "notification.label.quote": "{name} je citirao/la vašu objavu",
  "notification.label.reply": "Odgovor",
  "notification.list_status": "{name} objava je dodana na {listName}",
  "notification.mention": "Spomen",
  "notification.mentioned_you": "{name} vas je spomenuo/la",
  "notification.moderation-warning.learn_more": "Saznaj više",
  "notification.moderation_warning": "Dobili ste moderatorsko upozorenje",
  "notification.moderation_warning.action_delete_statuses": "Neke od vaših objava su uklonjene.",
  "notification.moderation_warning.action_disable": "Vaš račun je onemogućen.",
  "notification.moderation_warning.action_force_cw": "Nekim od vaših objava dodan je tekst upozorenja o sadržaju.",
  "notification.moderation_warning.action_mark_statuses_as_sensitive": "Neke od vaših objava su označene kao osjetljive.",
  "notification.moderation_warning.action_none": "Vaš račun je dobio moderatorsko upozorenje.",
  "notification.moderation_warning.action_sensitive": "Vaše objave će od sada biti označene kao osjetljive.",
  "notification.moderation_warning.action_silence": "Vaš račun je ograničen.",
  "notification.moderation_warning.action_suspend": "Vaš račun je suspendiran.",
  "notification.own_poll": "Vaša anketa je završila",
  "notification.poll": "Anketa u kojoj ste glasali je završila",
  "notification.quoted_update": "{name} je uredio/la objavu koju ste citirali",
  "notification.reblog": "{name} je pojačao/la vašu objavu",
  "notification.reblog.name_and_others_with_link": "{name} i <a>{count, plural, one {# drugi} other {# drugih}}</a> su pojačali vašu objavu",
  "notification.relationships_severance_event": "Izgubljene veze s {name}",
  "notification.relationships_severance_event.account_suspension": "Administrator s {from} je suspendirao/la {target}, što znači da više ne možete primati ažuriranja od njih niti komunicirati s njima.",
  "notification.relationships_severance_event.domain_block": "Administrator s {from} je blokirao/la {target}, uključujući {followersCount} vaših sljedbenika i {followingCount, plural, one {# račun} other {# računa}} koje pratite.",
  "notification.relationships_severance_event.learn_more": "Saznaj više",
  "notification.relationships_severance_event.user_domain_block": "Blokirali ste {target}, uklanjajući {followersCount} vaših sljedbenika i {followingCount, plural, one {# račun} other {# računa}} koje pratite.",
  "notification.status": "{name} je upravo objavio/la",
  "notification.status_reference": "{name} je povezao/la vašu objavu",
  "notification.update": "{name} je uredio/la objavu",
  "notification_requests.accept": "Prihvati",
  "notification_requests.accept_multiple": "{count, plural, one {Prihvati # zahtjev…} other {Prihvati # zahtjeva…}}",
  "notification_requests.confirm_accept_multiple.button": "{count, plural, one {Prihvati zahtjev} other {Prihvati zahtjeve}}",
  "notification_requests.confirm_accept_multiple.message": "Upravo ćete prihvatiti {count, plural, one {jedan zahtjev za obavijest} other {# zahtjeva za obavijest}}. Jeste li sigurni da želite nastaviti?",
  "notification_requests.confirm_accept_multiple.title": "Prihvatiti zahtjeve za obavijest?",
  "notification_requests.confirm_dismiss_multiple.button": "{count, plural, one {Odbaci zahtjev} other {Odbaci zahtjeve}}",
  "notification_requests.confirm_dismiss_multiple.message": "Upravo ćete odbaciti {count, plural, one {jedan zahtjev za obavijest} other {# zahtjeva za obavijest}}. Nećete moći lako pristupiti {count, plural, one {njemu} other {njima}} ponovno. Jeste li sigurni da želite nastaviti?",
  "notification_requests.confirm_dismiss_multiple.title": "Odbaciti zahtjeve za obavijest?",
  "notification_requests.dismiss": "Odbaci",
  "notification_requests.dismiss_multiple": "{count, plural, one {Odbaci # zahtjev…} other {Odbaci # zahtjeva…}}",
  "notification_requests.edit_selection": "Uredi",
  "notification_requests.exit_selection": "Gotovo",
  "notification_requests.explainer_for_limited_account": "Obavijesti s ovog računa su filtrirane jer je račun ograničen od strane moderatora.",
  "notification_requests.explainer_for_limited_remote_account": "Obavijesti s ovog računa su filtrirane jer je račun ili njegov poslužitelj ograničen od strane moderatora.",
  "notification_requests.maximize": "Maksimiziraj",
  "notification_requests.minimize_banner": "Minimiziraj banner filtriranih obavijesti",
  "notification_requests.notifications_from": "Obavijesti od {name}",
  "notification_requests.title": "Filtrirane obavijesti",
  "notification_requests.view": "Pogledaj obavijesti",
  "notifications.clear": "Očisti obavijesti",
  "notifications.clear_confirmation": "Jeste li sigurni da želite trajno očistiti sve svoje obavijesti?",
  "notifications.clear_title": "Očistiti obavijesti?",
  "notifications.column_settings.admin.report": "Nove prijave:",
  "notifications.column_settings.admin.sign_up": "Nove prijave:",
  "notifications.column_settings.alert": "Obavijesti na radnoj površini",
  "notifications.column_settings.emoji_reaction": "Emoji reakcije:",
  "notifications.column_settings.favourite": "Favoriti:",
  "notifications.column_settings.filter_bar.advanced": "Prikaži sve kategorije",
  "notifications.column_settings.filter_bar.category": "Brza traka filtera",
  "notifications.column_settings.follow": "Novi pratitelji:",
  "notifications.column_settings.follow_request": "Novi zahtjevi za praćenjem:",
  "notifications.column_settings.group": "Grupa",
  "notifications.column_settings.list_status": "Nove objave popisa:",
  "notifications.column_settings.mention": "Spomeni:",
  "notifications.column_settings.poll": "Rezultati ankete:",
  "notifications.column_settings.push": "Push obavijesti",
  "notifications.column_settings.quote": "Citati:",
  "notifications.column_settings.reblog": "Pojačanja:",
  "notifications.column_settings.show": "Prikaži u stupcu",
  "notifications.column_settings.sound": "Reproduciraj zvuk",
  "notifications.column_settings.status": "Nove objave:",
  "notifications.column_settings.status_reference": "Poveznice:",
  "notifications.column_settings.unread_notifications.category": "Nepročitane obavijesti",
  "notifications.column_settings.unread_notifications.highlight": "Istakni nepročitane obavijesti",
  "notifications.column_settings.update": "Uređivanja:",
  "notifications.filter.all": "Sve",
  "notifications.filter.boosts": "Pojačanja",
  "notifications.filter.emoji_reactions": "Žigovi",
  "notifications.filter.favourites": "Favoriti",
  "notifications.filter.follows": "Praćenja",
  "notifications.filter.mentions": "Spomeni",
  "notifications.filter.polls": "Rezultati ankete",
  "notifications.filter.status_references": "Poveznice",
  "notifications.filter.statuses": "Ažuriranja od ljudi koje pratite",
  "notifications.grant_permission": "Dodijeli dopuštenje.",
  "notifications.group": "{count} obavijesti",
  "notifications.mark_as_read": "Označi svaku obavijest kao pročitanu",
  "notifications.permission_denied": "Obavijesti na radnoj površini nisu dostupne zbog prethodno odbijenog zahtjeva za dopuštenja preglednika",
  "notifications.permission_denied_alert": "Obavijesti na radnoj površini ne mogu se omogućiti jer je dopuštenje preglednika prethodno odbijeno",
  "notifications.permission_required": "Obavijesti na radnoj površini nisu dostupne jer potrebno dopuštenje nije dodijeljeno.",
  "notifications.policy.accept": "Prihvati",
  "notifications.policy.accept_hint": "Prikaži u obavijestima",
  "notifications.policy.drop": "Zanemari",
  "notifications.policy.drop_hint": "Pošalji u prazno, da se nikad više ne vidi",
  "notifications.policy.filter": "Filtriraj",
  "notifications.policy.filter_hint": "Pošalji u filtriranu poštu obavijesti",
  "notifications.policy.filter_limited_accounts_hint": "Ograničeno od strane moderatora poslužitelja",
  "notifications.policy.filter_limited_accounts_title": "Moderirani računi",
  "notifications.policy.filter_new_accounts.hint": "Kreirano u posljednjih {days, plural, one {jedan dan} other {# dana}}",
  "notifications.policy.filter_new_accounts_title": "Novi računi",
  "notifications.policy.filter_not_followers_hint": "Uključujući ljude koji vas prate manje od {days, plural, one {jednog dana} other {# dana}}",
  "notifications.policy.filter_not_followers_title": "Ljudi koji vas ne prate",
  "notifications.policy.filter_not_following_hint": "Dok ih ručno ne odobrite",
  "notifications.policy.filter_not_following_title": "Ljudi koje ne pratite",
  "notifications.policy.filter_private_mentions_hint": "Filtrirano osim ako je odgovor na vaš vlastiti spomen ili ako pratite pošiljatelja",
  "notifications.policy.filter_private_mentions_title": "Neželjene privatne poruke",
  "notifications.policy.title": "Upravljaj obavijestima od…",
  "notifications_permission_banner.enable": "Omogući obavijesti na radnoj površini",
  "notifications_permission_banner.how_to_control": "Da primate obavijesti kada Mastodon nije otvoren, omogućite obavijesti na radnoj površini. Možete kontrolirati točno koje vrste interakcija generiraju obavijesti na radnoj površini putem gumba {icon} iznad nakon što su omogućene.",
  "notifications_permission_banner.title": "Nikad ništa ne propustite",
  "onboarding.follows.back": "Natrag",
  "onboarding.follows.done": "Gotovo",
  "onboarding.follows.empty": "Nažalost, trenutno se ne mogu prikazati rezultati. Možete pokušati koristiti pretraživanje ili pregledavati stranicu za istraživanje kako biste pronašli ljude za pratiti, ili pokušati ponovno kasnije.",
  "onboarding.follows.search": "Traži",
  "onboarding.follows.title": "Pratite ljude da započnete",
  "onboarding.profile.discoverable": "Učini moj profil pronalaživim",
  "onboarding.profile.discoverable_hint": "Kada se odlučite za pronalaživost na Mastodonu, vaše objave se mogu pojaviti u rezultatima pretraživanja i trendovima, a vaš profil se može predložiti ljudima sa sličnim interesima kao vi.",
  "onboarding.profile.display_name": "Prikazano ime",
  "onboarding.profile.display_name_hint": "Vaše puno ime ili vaše zabavno ime…",
  "onboarding.profile.note": "Biografija",
  "onboarding.profile.note_hint": "Možete @spomenuti druge ljude ili #oznake…",
  "onboarding.profile.save_and_continue": "Spremi i nastavi",
  "onboarding.profile.title": "Postavljanje profila",
  "onboarding.profile.upload_avatar": "Učitaj sliku profila",
  "onboarding.profile.upload_header": "Učitaj zaglavlje profila",
  "password_confirmation.exceeds_maxlength": "Potvrda lozinke premašuje maksimalnu duljinu lozinke",
  "password_confirmation.mismatching": "Potvrda lozinke se ne podudara",
  "picture_in_picture.restore": "Vrati natrag",
  "poll.closed": "Zatvoreno",
  "poll.refresh": "Osvježi",
  "poll.reveal": "Vidi rezultate",
  "poll.total_people": "{count, plural, one {# osoba} other {# osoba}}",
  "poll.total_votes": "{count, plural, one {# glas} other {# glasova}}",
  "poll.vote": "Glasaj",
  "poll.voted": "Glasali ste za ovaj odgovor",
  "poll.votes": "{votes, plural, one {# glas} other {# glasova}}",
  "poll_button.add_poll": "Dodaj anketu",
  "poll_button.remove_poll": "Ukloni anketu",
  "privacy.banned.long": "Svi javni podnosi raspona su onemogućeni. Potrebno je modificirati postavke korisnika.",
  "privacy.banned.short": "Nema objavljivanja",
  "privacy.change": "Promijeni privatnost objave",
  "privacy.circle.long": "Samo članovi kruga",
  "privacy.circle.short": "Krug",
  "privacy.direct.long": "Svi spomenuti u objavi",
  "privacy.direct.short": "Privatni spomen",
  "privacy.limited.short": "Ograničeno",
  "privacy.login.long": "Vidljivo samo prijavljenim korisnicima",
  "privacy.login.short": "Samo prijava",
  "privacy.mutual.long": "Samo uzajamni pratioci",
  "privacy.mutual.short": "Uzajamno",
  "privacy.personal.short": "Samo za sebe",
  "privacy.private.long": "Samo vaši pratioci",
  "privacy.private.short": "Pratioci",
  "privacy.public.long": "Dostupno na cijelom fediversu",
  "privacy.public.short": "Javno",
  "privacy.public_unlisted.long": "Vidljivo za sve bez GTL",
  "privacy.public_unlisted.short": "Lokalno javno",
  "privacy.quote.anyone": "{visibility}, bilo tko može citirati",
  "privacy.quote.disabled": "{visibility}, citiranje onemogućeno",
  "privacy.quote.limited": "{visibility}, citiranje ograničeno",
  "privacy.reply.long": "Odgovori na ograničenu objavu",
  "privacy.reply.short": "Odgovor",
  "privacy.unlisted.additional": "Ovo se ponaša potpuno kao javno, osim što se objava neće pojaviti u live feedovima ili oznakama, istraživanju ili Mastodon pretraživanju, čak i ako ste odabrali širok pristup računu.",
  "privacy.unlisted.long": "Skriveno od rezultata pretraživanja, trendova i javnih vremenskih traka",
  "privacy.unlisted.short": "Tihi javni",
  "privacy_policy.last_updated": "Zadnje ažurirano {date}",
  "privacy_policy.title": "Pravila privatnosti",
  "quote_error.poll": "Citat nije dopušten s anketama.",
  "quote_error.quote": "Dopušten je samo jedan citat odjednom.",
  "quote_error.unauthorized": "Niste ovlašteni citirati ovu objavu.",
  "quote_error.upload": "Citat nije dopušten s privitcima medija.",
  "reaction_deck.add": "Dodaj",
  "recommended": "Preporučeno",
  "refresh": "Osvježi",
  "regeneration_indicator.please_stand_by": "Molimo pričekajte.",
  "regeneration_indicator.preparing_your_home_feed": "Priprema vašeg početnog feeda…",
  "relative_time.days": "{number}d",
  "relative_time.full.days": "{number, plural, one {# dan} other {# dana}} prije",
  "relative_time.full.hours": "{number, plural, one {# sat} other {# sati}} prije",
  "relative_time.full.just_now": "upravo sada",
  "relative_time.full.minutes": "{number, plural, one {# minuta} other {# minuta}} prije",
  "relative_time.full.seconds": "{number, plural, one {# sekunda} other {# sekundi}} prije",
  "relative_time.hours": "{number}h",
  "relative_time.just_now": "sada",
  "relative_time.minutes": "{number}m",
  "relative_time.seconds": "{number}s",
  "relative_time.today": "danas",
  "remove_quote_hint.button_label": "Shvaćam",
  "remove_quote_hint.message": "Možete to učiniti iz izbornika opcija {icon}.",
  "remove_quote_hint.title": "Želite ukloniti svoju citiranu objavu?",
  "reply_indicator.attachments": "{count, plural, one {# privitak} other {# privitaka}}",
  "reply_indicator.cancel": "Otkaži",
  "reply_indicator.poll": "Anketa",
  "report.block": "Blokiraj",
  "report.block_explanation": "Nećete vidjeti njihove objave. Oni neće moći vidjeti vaše objave niti vas pratiti. Moći će vidjeti da su blokirani.",
  "report.categories.legal": "Pravno",
  "report.categories.other": "Ostalo",
  "report.categories.spam": "Spam",
  "report.categories.violation": "Sadržaj krši jedno ili više pravila poslužitelja",
  "report.category.subtitle": "Odaberite najbolje podudaranje",
  "report.category.title": "Recite nam što se događa s ovim {type}",
  "report.category.title_account": "profilom",
  "report.category.title_status": "objavom",
  "report.close": "Gotovo",
  "report.comment.title": "Ima li još nešto što mislimo da bismo trebali znati?",
  "report.forward": "Proslijedi na {target}",
  "report.forward_hint": "Račun je s drugog poslužitelja. Poslati tamo također anonimiziranu kopiju prijave?",
  "report.mute": "Utišaj",
  "report.mute_explanation": "Nećete vidjeti njihove objave. Oni i dalje mogu pratiti vas i vidjeti vaše objave i neće znati da su utišani.",
  "report.next": "Sljedeće",
  "report.placeholder": "Dodatni komentari",
  "report.reasons.dislike": "Ne sviđa mi se",
  "report.reasons.dislike_description": "Nije nešto što želite vidjeti",
  "report.reasons.legal": "Ilegalno je",
  "report.reasons.legal_description": "Vjerujete da krši zakon vaše ili zemlje poslužitelja",
  "report.reasons.other": "Nešto drugo",
  "report.reasons.other_description": "Problem se ne uklapa u druge kategorije",
  "report.reasons.spam": "To je spam",
  "report.reasons.spam_description": "Zlonamjerne poveznice, lažni angažman ili ponavljajući odgovori",
  "report.reasons.violation": "Krši pravila poslužitelja",
  "report.reasons.violation_description": "Svjesni ste da krši specifična pravila",
  "report.rules.subtitle": "Odaberite sve koji se primjenjuju",
  "report.rules.title": "Koja pravila su prekršena?",
  "report.statuses.subtitle": "Odaberite sve koji se primjenjuju",
  "report.statuses.title": "Ima li objava koje podupiru ovu prijavu?",
  "report.submit": "Pošalji",
  "report.target": "Prijava {target}",
  "report.thanks.take_action": "Ovdje su vaše opcije za kontrolu onoga što vidite na Mastodonu:",
  "report.thanks.take_action_actionable": "Dok ovo pregledavamo, možete poduzeti mjere protiv @{name}:",
  "report.thanks.title": "Ne želite ovo vidjeti?",
  "report.thanks.title_actionable": "Hvala na prijavi, pogledat ćemo ovo.",
  "report.unfollow": "Prestani pratiti @{name}",
  "report.unfollow_explanation": "Pratite ovaj račun. Da više ne vidite njihove objave u svom početnom feedu, prestanite ih pratiti.",
  "report_notification.attached_statuses": "{count, plural, one {{count} objava} other {{count} objava}} priloženo",
  "report_notification.categories.legal": "Pravno",
  "report_notification.categories.legal_sentence": "ilegalni sadržaj",
  "report_notification.categories.other": "Ostalo",
  "report_notification.categories.other_sentence": "ostalo",
  "report_notification.categories.spam": "Spam",
  "report_notification.categories.spam_sentence": "spam",
  "report_notification.categories.violation": "Kršenje pravila",
  "report_notification.categories.violation_sentence": "kršenje pravila",
  "report_notification.open": "Otvori prijavu",
  "search.clear": "Očisti pretraživanje",
  "search.no_recent_searches": "Nema nedavnih pretraživanja",
  "search.placeholder": "Traži",
  "search.quick_action.account_search": "Profili koji odgovaraju {x}",
  "search.quick_action.go_to_account": "Idi na profil {x}",
  "search.quick_action.go_to_hashtag": "Idi na oznaku {x}",
  "search.quick_action.open_url": "Otvori URL u Mastodonu",
  "search.quick_action.status_search": "Objave koje odgovaraju {x}",
  "search.search_or_paste": "Traži ili zalijepi URL",
  "search_popout.domain": "domena",
  "search_popout.full_text_search_disabled_message": "Nije dostupno na {domain}.",
  "search_popout.full_text_search_logged_out_message": "Dostupno samo kada ste prijavljeni.",
  "search_popout.language_code": "ISO jezični kod",
  "search_popout.options": "Opcije pretraživanja",
  "search_popout.quick_actions": "Brze radnje",
  "search_popout.recent": "Nedavna pretraživanja",
  "search_popout.specific_date": "specifični datum",
  "search_popout.user": "korisnik",
  "search_results.accounts": "Profili",
  "search_results.all": "Sve",
  "search_results.hashtags": "Oznake",
  "search_results.no_results": "Nema rezultata.",
  "search_results.no_search_yet": "Pokušajte tražiti objave, profile ili oznake.",
  "search_results.see_all": "Vidi sve",
  "search_results.statuses": "Objave",
  "search_results.title": "Traži \"{q}\"",
  "searchability.change": "Promijeni mogućnost pretraživanja objave",
  "searchability.direct.long": "Nitko ne može pronaći, ali vi možete",
  "searchability.direct.short": "Samo za sebe",
  "searchability.private.long": "Reagirajući na ovu objavu mogu pronaći",
  "searchability.private.short": "Reagirajući",
  "searchability.public.long": "Svatko može pronaći",
  "searchability.public.short": "Svi",
  "searchability.public_unlisted.long": "Lokalni korisnici i pratioci mogu pronaći",
  "searchability.public_unlisted.short": "Lokalno i pratioci",
  "searchability.unlisted.long": "Vaši pratioci i reagirajući mogu pronaći",
  "searchability.unlisted.short": "Pratioci i reagirajući",
  "server_banner.about_active_users": "Ljudi koji koriste ovaj poslužitelj tijekom posljednjih 30 dana (Mjesečno aktivni korisnici)",
  "server_banner.active_users": "aktivni korisnici",
  "server_banner.administered_by": "Administrira:",
  "server_banner.is_one_of_many": "{domain} je neovisni poslužitelj usredotočen na privatnost, zajednicu i vašu slobodu govora.",
  "server_banner.server_stats": "Statistike poslužitelja:",
  "sign_in_banner.create_account": "Kreiraj račun",
  "sign_in_banner.follow_anyone": "Pratite bilo koga diljem fediverzuma i doživite vremensku traku bez algoritama, oglasa ili clickbaita — samo sadržaj koji želite.",
  "sign_in_banner.mastodon_is": "Oslobodite se velikih tech kompanija — pridružite se našoj zajednici i povratite svoj glas.",
  "sign_in_banner.sign_in": "Prijava",
  "sign_in_banner.sso_redirect": "Prijava ili Registracija",
  "status.admin_account": "Otvori sučelje moderiranja za @{name}",
  "status.admin_domain": "Otvori sučelje moderiranja za {domain}",
  "status.admin_status": "Otvori ovu objavu u sučelju moderiranja",
  "status.all_disabled": "Pojačanja i citati su onemogućeni",
  "status.block": "Blokiraj @{name}",
  "status.bookmark": "Zabilježi",
  "status.bookmark_category": "Kategorija zabilješki",
  "status.cancel_reblog": "Poništi podizanje",
  "status.cancel_reblog_private": "Opozovi pojačanje",
  "status.cannot_quote": "Nije vam dopušteno citirati ovu objavu",
  "status.cannot_reblog": "Ova objava se ne može pojačati",
  "status.cannot_reference": "Ovaj poslužitelj ne može primiti poveznicu",
  "status.contains_quote": "Sadrži citat",
  "status.context.loading": "Učitavanje više odgovora",
  "status.context.loading_error": "Nije moguće učitati nove odgovore",
  "status.context.loading_more": "Učitavanje više odgovora",
  "status.context.loading_success": "Svi odgovori učitani",
  "status.context.more_replies_found": "Pronađeno više odgovora",
  "status.context.retry": "Pokušaj ponovno",
  "status.context.show": "Prikaži",
  "status.continued_thread": "Nastavljeni razgovor",
  "status.copy": "Kopiraj poveznicu na objavu",
  "status.delete": "Izbriši",
  "status.delete.success": "Objava izbrisana",
  "status.detailed_status": "Detaljni prikaz razgovora",
  "status.direct": "Privatno spomeni @{name}",
  "status.direct_indicator": "Privatni spomen",
  "status.edit": "Uredi",
  "status.edited": "Zadnji put uređeno {date}",
  "status.edited_x_times": "Uređeno {count, plural, one {{count} put} other {{count} puta}}",
  "status.embed": "Preuzmi kod za ugradnju",
  "status.emoji_reaction": "Emoji reakcija",
  "status.emoji_reaction.pick": "Odaberi emoji reakciju",
  "status.emoji_reactions": "{count, plural, one {emoji} other {emojia}}",
  "status.expiration.12_hours": "Ukloni za 12 sati",
  "status.expiration.1_day": "Ukloni za 1 dan",
  "status.expiration.1_hour": "Ukloni za 1 sat",
  "status.expiration.30_minutes": "Ukloni za 30 minuta",
  "status.expiration.3_hours": "Ukloni za 3 sata",
  "status.expiration.5_minutes": "Ukloni za 5 minuta",
  "status.expiration.7_days": "Ukloni za 7 dana",
  "status.expiration.add": "Postavi vrijeme isteka statusa",
  "status.favourite": "Omilji",
  "status.favourites": "{count, plural, one {favorit} other {favorita}}",
  "status.featured_tags.add": "Dodaj svoju istaknutu oznaku",
  "status.filter": "Filtriraj ovu objavu",
  "status.history.created": "{name} kreirano {date}",
  "status.history.edited": "{name} uređeno {date}",
  "status.load_more": "Učitaj više",
  "status.media.open": "Klikni za otvaranje",
  "status.media.show": "Klikni za prikaz",
  "status.media_hidden": "Medij skriven",
  "status.mention": "Spomeni @{name}",
  "status.mentions": "Spomenuti računi",
  "status.more": "Više",
  "status.mute": "Utišaj @{name}",
  "status.mute_conversation": "Utišaj razgovor",
  "status.open": "Proširi ovu objavu",
  "status.pin": "Pribilježi na profilu",
  "status.quote": "Citiraj",
  "status.quote.cancel": "Otkaži citat",
  "status.quote_error.filtered": "Skriveno zbog jednog od vaših filtera",
  "status.quote_error.limited_account_hint.action": "Svejedno prikaži",
  "status.quote_error.limited_account_hint.title": "Ovaj račun su sakrili moderatori {domain}.",
  "status.quote_error.not_available": "Objava nedostupna",
  "status.quote_error.not_found": "Ova objava se ne može prikazati.",
  "status.quote_error.pending_approval": "Objava na čekanju",
  "status.quote_error.pending_approval_popout.body": "Na Mastodonu, možete kontrolirati može li vas netko citirati. Ova objava je na čekanju dok dobivamo odobrenje izvornog autora.",
  "status.quote_error.rejected": "Ova objava se ne može prikazati jer originalni autor ne dopušta citiranje.",
  "status.quote_error.removed": "Ovu objavu je uklonio njen autor.",
  "status.quote_error.revoked": "Objava uklonjena od strane autora",
  "status.quote_error.unauthorized": "Ova objava se ne može prikazati jer niste ovlašteni za njen pregled.",
  "status.quote_followers_only": "Samo pratioci mogu citirati ovu objavu",
  "status.quote_link": "Umetni poveznicu citata",
  "status.quote_manual_review": "Autor će ručno pregledati",
  "status.quote_noun": "Citat",
  "status.quote_policy_change": "Promijeni tko može citirati",
  "status.quote_post_author": "Citirao/la objavu od @{name}",
  "status.quote_private": "Privatne objave se ne mogu citirati",
  "status.quotes": "{count, plural, one {citat} other {citata}}",
  "status.quotes.empty": "Još nitko nije citirao ovu objavu. Kada netko to učini, pojavit će se ovdje.",
  "status.quotes.local_other_disclaimer": "Citati koje je autor odbio neće biti prikazani.",
  "status.quotes.remote_other_disclaimer": "Samo citati s {domain} su zajamčeno prikazani ovdje. Citati koje je autor odbio neće biti prikazani.",
  "status.read_more": "Pročitaj više",
  "status.reblog": "Pojačaj",
  "status.reblog_or_quote": "Pojačaj ili citiraj",
  "status.reblog_private": "Podijeli ponovno sa svojim pratiteljima",
  "status.reblog_with_detail": "Pojačaj s vidljivošću",
  "status.reblogged_by": "{name} je pojačao/la",
  "status.reblogs": "{count, plural, one {pojačanje} other {pojačanja}}",
  "status.reblogs.empty": "Još nitko nije pojačao ovu objavu. Kada netko to učini, pojavit će se ovdje.",
  "status.redraft": "Izbriši & ponovno napiši",
  "status.reference": "Poveznica",
  "status.reference_link": "Umetni poveznicu objave",
  "status.references": "{count, plural, one {poveznica} other {poveznica}}",
  "status.remove_bookmark": "Ukloni zabilješku",
  "status.remove_favourite": "Ukloni iz favorita",
  "status.remove_quote": "Ukloni",
  "status.replied_in_thread": "Odgovoreno u razgovoru",
  "status.replied_to": "Odgovoreno {name}",
  "status.reply": "Odgovori",
  "status.replyAll": "Odgovori na razgovor",
  "status.report": "Prijavi @{name}",
  "status.request_quote": "Zatraži citat",
  "status.revoke_quote": "Ukloni moju objavu iz objave @{name}",
  "status.sensitive_warning": "Osjetljivi sadržaj",
  "status.share": "Podijeli",
  "status.show_less_all": "Prikaži manje za sve",
  "status.show_more_all": "Prikaži više za sve",
  "status.show_original": "Prikaži izvorno",
  "status.title.with_attachments": "{user} je objavio/la {attachmentCount, plural, one {jedan privitak} other {{attachmentCount} privitaka}}",
  "status.translate": "Prevedi",
  "status.translated_from_with": "Prevedeno s {lang} pomoću {provider}",
  "status.uncached_media_warning": "Pregled nije dostupan",
  "status.unmute_conversation": "Poništi utišavanje razgovora",
  "status.unpin": "Ukloni pribilježak s profila",
  "subscribed_languages.lead": "Samo objave na odabranim jezicima će se pojaviti na vašim početnim i popisnim vremenskim trakama nakon promjene. Odaberite ništa da primate objave na svim jezicima.",
  "subscribed_languages.save": "Spremi promjene",
  "subscribed_languages.target": "Promijeni pretplaćene jezike za {target}",
  "tabs_bar.home": "Početni",
  "tabs_bar.menu": "Izbornik",
  "tabs_bar.notifications": "Obavijesti",
  "tabs_bar.publish": "Nova objava",
  "tabs_bar.search": "Traži",
  "terms_of_service.effective_as_of": "Na snazi od {date}",
  "terms_of_service.title": "Uvjeti korištenja",
  "terms_of_service.upcoming_changes_on": "Nadolazeće promjene na {date}",
  "time_remaining.days": "{number, plural, one {# dan} other {# dana}} preostalo",
  "time_remaining.hours": "{number, plural, one {# sat} other {# sati}} preostalo",
  "time_remaining.minutes": "{number, plural, one {# minuta} other {# minuta}} preostalo",
  "time_remaining.moments": "Trenuci preostali",
  "time_remaining.seconds": "{number, plural, one {# sekunda} other {# sekundi}} preostalo",
  "trends.counter_by_accounts": "{count, plural, one {{counter} osoba} other {{counter} ljudi}} u posljednjih {days, plural, one {dan} other {{days} dana}}",
  "trends.trending_now": "Trenutno u trendu",
  "ui.beforeunload": "Vaš nacrt će biti izgubljen ako napustite Mastodon.",
  "units.short.billion": "{count} mlrd.",
  "units.short.million": "{count} mil.",
  "units.short.thousand": "{count} tis.",
  "upload_area.title": "Povuci i ispusti za učitavanje",
  "upload_button.label": "Dodaj slike, video ili audio datoteku",
  "upload_error.limit": "Prekoračeno ograničenje učitavanja datoteke.",
  "upload_error.poll": "Učitavanje datoteke nije dopušteno s anketama.",
  "upload_error.quote": "Učitavanje datoteke nije dopušteno s citatima.",
  "upload_form.drag_and_drop.instructions": "Za odabir medijskog privitka, pritisnite razmaknicu ili enter. Dok vučete, koristite tipke strelica za pomicanje medijskog privitka u bilo kojem smjeru. Pritisnite razmaknicu ili enter ponovno za ispuštanje medijskog privitka na njegovu novu poziciju, ili pritisnite escape za otkazivanje.",
  "upload_form.drag_and_drop.on_drag_cancel": "Povlačenje je otkazano. Medijski privitak {item} je ispušten.",
  "upload_form.drag_and_drop.on_drag_end": "Medijski privitak {item} je ispušten.",
  "upload_form.drag_and_drop.on_drag_over": "Medijski privitak {item} je pomaknut.",
  "upload_form.drag_and_drop.on_drag_start": "Podignut medijski privitak {item}.",
  "upload_form.edit": "Uredi",
  "upload_progress.label": "Učitavanje...",
  "upload_progress.processing": "Obrada…",
  "username.taken": "To korisničko ime je zauzeto. Pokušajte drugo",
  "video.close": "Zatvori video",
  "video.download": "Preuzmi datoteku",
  "video.exit_fullscreen": "Izađi iz cijelog zaslona",
  "video.expand": "Proširi video",
  "video.fullscreen": "Cijeli zaslon",
  "video.hide": "Sakrij video",
  "video.mute": "Utišaj",
  "video.pause": "Pauziraj",
  "video.play": "Reproduciraj",
  "video.skip_backward": "Skoči unatrag",
  "video.skip_forward": "Skoči unaprijed",
  "video.unmute": "Poništi utišavanje",
  "video.volume_down": "Smanji glasnoću",
  "video.volume_up": "Povećaj glasnoću",
  "visibility_modal.button_title": "Postavi vidljivost",
  "visibility_modal.circle_label": "Krug",
  "visibility_modal.header": "Vidljivost i interakcija",
  "visibility_modal.helper.direct_quoting": "Privatni spomeni napisani na Mastodonu ne mogu biti citirani od strane drugih.",
  "visibility_modal.helper.privacy_editing": "Vidljivost se ne može promijeniti nakon što je objava objavljena.",
  "visibility_modal.helper.privacy_private_self_quote": "Samocitati privatnih objava ne mogu biti javni.",
  "visibility_modal.helper.private_quoting": "Objave samo za sljedbenike napisane na Mastodonu ne mogu biti citirane od strane drugih.",
  "visibility_modal.helper.searchability_editing": "Mogućnost pretraživanja se ne može promijeniti nakon što je objava objavljena.",
  "visibility_modal.helper.unlisted_quoting": "Kada vas ljudi citiraju, njihova objava će također biti skrivena od trendovskih vremenskih traka.",
  "visibility_modal.instructions": "Kontrolirajte tko može komunicirati s ovom objavom. Također možete primijeniti postavke na sve buduće objave navigacijom do <link>Postavke > Zadane postavke objave</link>.",
  "visibility_modal.privacy_label": "Vidljivost",
  "visibility_modal.quote_followers": "Samo pratitelji",
  "visibility_modal.quote_label": "Tko može citirati",
  "visibility_modal.quote_nobody": "Samo ja",
  "visibility_modal.quote_public": "Bilo tko",
  "visibility_modal.save": "Spremi",
  "visibility_modal.searchability_label": "Mogućnost pretraživanja"
}
